<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <form
    #df="ngForm"
    novalidate
    (keydown.enter)="onSearchAccountStatement(false)"
    class="formborder"
  >
    <div class="row m-0 col-md-12 p-0 align-items-center">
      <div class="col-md-4">
        <span class="required-lable">Account Head</span>

        <input
          type="text"
          [formControl]="AccountControl"
          [matAutocomplete]="auto"
          class="form-control input-text-css"
          [(ngModel)]="chhead"
          name="chhead"
          required
          [class.alert-warning]="chhead == ''"
          placeholder="Account Head"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayFn"
          (optionSelected)="onAccountHeadhSelect($event)"
        >
          <mat-option
            *ngFor="let account of filteredAccountHead | async"
            [value]="account"
          >
            {{ account.Account_Name }}
          </mat-option>
        </mat-autocomplete>
      </div>
      <div class="col-md-2">
        <span> Balance Type</span>
        <select
          name="BalanceType"
          id="BalanceType"
          class="form-control input-text-css"
          [(ngModel)]="BalanceType"
          
        >
          <option [value]="0">Annually</option>
          <option [value]="1">Monthly</option>
          <option [value]="2">Daily</option>
        </select>
      </div>
      <div class="col-md-2">
        <span class="required-lable">Date From</span>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="VoucherDateFrom"
            id="VoucherDateFrom"
            [min]="minDate"
            [max]="maxDate"
            (dateChange)="DateChange()"
            class="form-control input-text-css"
            [(ngModel)]="VoucherDateFrom"
            required
            #refVoucherDateFrom="ngModel"
            [ngClass]="{
              'is-invalid': df.submitted && refVoucherDateFrom.invalid,
              'alert-warning':
                refVoucherDateFrom.invalid &&
                (refVoucherDateFrom.dirty ||
                  refVoucherDateFrom.touched ||
                  refVoucherDateFrom.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
        <!-- <input
          name="VoucherDateFrom"
          [(ngModel)]="VoucherDateFrom"
          id="VoucherDateFrom"
          [minDate]="minDate"
          [maxDate]="maxDate"
          placeholder="Voucher From"
          class="form-control input-text-css"
          bsDatepicker
          (ngModelChange)="DateChange()"
          required
          #refVoucherDateFrom="ngModel"
          [ngClass]="{
            'is-invalid': df.submitted && refVoucherDateFrom.invalid,
            'alert-warning':
              refVoucherDateFrom.invalid &&
              (refVoucherDateFrom.dirty ||
                refVoucherDateFrom.touched ||
                refVoucherDateFrom.untouched)
          }"
        /> -->
      </div>
      <div class="col-md-2">
        <span class="required-lable">Date To</span>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker2"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="VoucherDateTo"
            id="VoucherDateTo"
            [min]="minDate"
            [max]="maxDate"
            class="form-control input-text-css"
            [(ngModel)]="VoucherDateTo"
            (dateChange)="DateChange()"
            required
            #reffVoucherDateTo="ngModel"
            [ngClass]="{
              'is-invalid': df.submitted && reffVoucherDateTo.invalid,
              'alert-warning':
                reffVoucherDateTo.invalid &&
                (reffVoucherDateTo.dirty ||
                  reffVoucherDateTo.touched ||
                  reffVoucherDateTo.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
        <!-- <input
          name="VoucherDateTo"
          [(ngModel)]="VoucherDateTo"
          id="VoucherDateTo"
          [minDate]="minDate"
          [maxDate]="maxDate"
          placeholder="Voucher To"
          class="form-control input-text-css"
          bsDatepicker
          (ngModelChange)="DateChange()"
          required
          #reffVoucherDateTo="ngModel"
          [ngClass]="{
            'is-invalid': df.submitted && reffVoucherDateTo.invalid,
            'alert-warning':
              reffVoucherDateTo.invalid &&
              (reffVoucherDateTo.dirty ||
                reffVoucherDateTo.touched ||
                reffVoucherDateTo.untouched)
          }"
        /> -->
      </div>
      <!-- <div class="col-md-2" *ngIf="BalanceType == 0">
      <span> Branch</span>
      <select
        name="SelectBranch"
        id="SelectBranch"
        #refSelectGender="ngModel"
        [(ngModel)]="SelectBranch"
        class="form-control input-text-css"
      >
        <option value="All">All</option>
        <option *ngFor="let branch of BranchesList" [value]="branch.BranchId">
          {{ branch.Branch_Name }}
        </option>
      </select>
    </div> -->
      <div class="col-md-2 text-right mb-2">
        <button
          type="button"
          (click)="onSearchAccountStatement(false)"
          class="mt-3 btn font-size-12 button-btn"
          [disabled]="!df.form.valid || !chhead"
        >
          Search
        </button>
      </div>
      <div class="col-md-12 float-right">
        <div class="col-md-4 float-right" *ngIf="dataSource">
          <form action="" class="search-text">
            <div class="bg-light rounded rounded-pill shadow-sm">
              <div class="input-group">
                <input
                  type="text"
                  id="FilterInputSearch"
                  (keyup)="applyFilterAnnually($event.target.value)"
                  name="FilterInputSearch"
                  placeholder="What're you searching for?"
                  class="form-control border-0 bg-light mt-2"
                />
                <div class="input-group-append">
                  <button
                    id="button-addon1"
                    type="submit"
                    class="btn btn-link text-primary"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="col-md-4 float-right" *ngIf="dataSourceMonthly">
          <form action="" class="search-text">
            <div class="bg-light rounded rounded-pill shadow-sm">
              <div class="input-group">
                <input
                  type="text"
                  id="FilterInputSearch"
                  (keyup)="applyFilterMonthly($event.target.value)"
                  name="FilterInputSearch"
                  placeholder="What're you searching for?"
                  class="form-control border-0 bg-light mt-2"
                />
                <div class="input-group-append">
                  <button
                    id="button-addon1"
                    type="submit"
                    class="btn btn-link text-primary"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="col-md-4 float-right" *ngIf="dataSourceDaily">
          <form action="" class="search-text">
            <div class="bg-light rounded rounded-pill shadow-sm">
              <div class="input-group">
                <input
                  type="text"
                  id="FilterInputSearch"
                  (keyup)="applyFilterDaily($event.target.value)"
                  name="FilterInputSearch"
                  placeholder="What're you searching for?"
                  class="form-control border-0 bg-light mt-2"
                />
                <div class="input-group-append">
                  <button
                    id="button-addon1"
                    type="submit"
                    class="btn btn-link text-primary"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
         <div class="col-md-4 float-left mt-4">
        <button class="btn btn button-btn mr-1" (click)="OnClickExpandAll()"  *ngIf="dataSource">
          Expand All
        </button>
        <button class="btn btn button-btn" (click)="OnClickCollaspeAll()"  *ngIf="dataSource">
          Collapse All
        </button>
      </div>
      </div>
     

    </div>
  </form>

  <div class="mt-3" *ngIf="dataSource">
    <div class="">
      <div class="table-responsive" style="overflow: auto">
        <table
          class="table-bordered simple-table"
          mat-table
          matSort

          [dataSource]="dataSource"
        >
          <!-- <ng-container matColumnDef="voucherid">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let row; let i = index">
              {{ PaginatorList.pageIndex * PaginatorList.pageSize + (i + 1) }}
            </td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container> -->
          <ng-container matColumnDef="voucherid">
            <th mat-header-cell *matHeaderCellDef>#</th>

            <td mat-cell *matCellDef="let row; let i = index">
              
              <button
                *ngIf="row.expandable"
                class="btn btn-sm btn-light toggle-btn"
                (click)="toggleVoucherByNo(row.VoucherId)"
                aria-label="Toggle voucher"
              >
                <strong>{{ row.expanded ? '-' : '+' }}</strong>
              </button>

              <!-- <span *ngIf="!row.expandable">
                {{ i + 1 }}
              </span> -->
            </td>

            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>
          <ng-container matColumnDef="VoucherDate">
            <th mat-header-cell *matHeaderCellDef>
              Voucher Date
            </th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.isParent">
              {{ row.VoucherDate }}
               </ng-container>
            </td>
         
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Voucher_No">
            <th mat-header-cell *matHeaderCellDef>
              Voucher No
            </th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.isParent">
              {{ row.Voucher_No }}
            </ng-container>
            </td>
              
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>
           <ng-container matColumnDef="Branch_Name">
            <th mat-header-cell *matHeaderCellDef>
              Branch Name
            </th>
            <td mat-cell *matCellDef="let row">
              <ng-container>
              {{ row.Branch_Name }}
            </ng-container>
            </td>
              
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="CaseNo">
            <th mat-header-cell *matHeaderCellDef>Loan No</th>
            <td mat-cell *matCellDef="let row">{{ row.CaseNo }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="accHead">
            <th mat-header-cell *matHeaderCellDef>A/C Head</th>
            <td mat-cell *matCellDef="let row">
             <div [style.paddingLeft.px]="row.isParent ? 0 : 24">
              {{ row.accHead }}
            </div>
            </td>
            <th mat-footer-cell *matFooterCellDef>Total</th>
          </ng-container>
          <ng-container matColumnDef="TranType">
            <!-- Header -->
            <th
              mat-header-cell
              *matHeaderCellDef
              class="text-center"
            >
              Details
            </th>

            <!-- Cell -->
            <td mat-cell *matCellDef="let row" class="text-right">
              <ng-container *ngIf="!row.isParent">
              <div *ngIf="row.TranTypeCR && row.TranTypeCR != 0">
                {{ row.TranTypeCR | number:'1.2-2' }} <span class="label-cr">(CR)</span>
              </div>

              <div *ngIf="row.TranTypeDR && row.TranTypeDR != 0">
                {{ row.TranTypeDR | number:'1.2-2' }} <span class="label-dr">(DR)</span>
              </div>
              </ng-container>
            </td>

            <!-- Footer -->
            <th mat-footer-cell *matFooterCellDef class="text-right">
            </th>
          </ng-container>


          <ng-container matColumnDef="TranTypeDR">
            <th
             
              mat-header-cell
              *matHeaderCellDef
              class="text-right"
            >
              DR Amount
            </th>
            <td mat-cell *matCellDef="let row" class="text-right">
              <ng-container *ngIf="row.isParent">
              {{ row.TranTypeDR }}
              </ng-container>
            </td>
            <th mat-footer-cell *matFooterCellDef class="text-right">
              {{ dataSource ? calculateACTranTypeDR() : "" }}
            </th>
          </ng-container>

          <ng-container matColumnDef="TranTypeCR">
            <th
             
              mat-header-cell
              *matHeaderCellDef
              class="text-right"
            >
              CR Amount
            </th>
            <td mat-cell *matCellDef="let row" class="text-right">
              <ng-container *ngIf="row.isParent">
              {{ row.TranTypeCR }}
              </ng-container>
            </td>
            <th mat-footer-cell *matFooterCellDef class="text-right">
              {{ dataSource ? calculateACTranTypeCR() : "" }}
            </th>
          </ng-container>

          <ng-container matColumnDef="TranTypeTotal" >
            <th
             
              mat-header-cell
              *matHeaderCellDef
              class="text-right"
            >
              Balance
            </th>
            <td mat-cell *matCellDef="let row" class="text-right">
              <ng-container *ngIf="row.isParent">
              {{ row.TranTypeTotal }}
              </ng-container>
            </td>
            <th mat-footer-cell *matFooterCellDef class="text-right" >
              {{ dataSource ? calculateACTranTypeTotal() : "" }}
            </th>
          </ng-container>

          <ng-container matColumnDef="Narration" >
            <th mat-header-cell *matHeaderCellDef>Narration</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.isParent">
              {{ row.Narration }}
            </ng-container>
            </td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Reference_No" >
            <th mat-header-cell *matHeaderCellDef>Reference No</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.isParent">
              {{ row.Reference_No }}
            </ng-container>
            </td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>


          <ng-container matColumnDef="ViewAction">
            <th
              mat-header-cell
             
              class="grid-header"
              *matHeaderCellDef
            >
              View Detail
            </th>
            <td
              mat-cell
              *matCellDef="let row; let i = index"
              class="text-center"
            >
            <ng-container *ngIf="row.isParent">
              <div *ngIf="row.accHead == 'Opening Balance'; else elseBlock">
                &nbsp;
              </div>
              <ng-template #elseBlock>
                <app-lms-voucher-view-model
                  [voucherid]="row.voucherid"
                  (close)="GetData($event)"
                  [index]="i"
                >
                  <i
                    class="fa fa-arrow-circle-right arrow-circle action-btn"
                    aria-label="true"
                  ></i>
                </app-lms-voucher-view-model>
              </ng-template>
            </ng-container>
            </td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
           [class.Row_Bold]="row.isParent"
               [style.backgroundColor]="row.isParent ? 'rgb(195 213 240)' : null"
            [class.child-row]="!row.isParent"
          ></tr>
          <tr
            mat-footer-row
            class="sticky-footer fontcolor"
            *matFooterRowDef="displayedColumns; sticky: true"
          ></tr>
        </table>
      </div>
    </div>
  </div>

    <!-- 
    [ngClass]="{
                'voucher-expanded-header': row.expanded && row.expandable,
                'voucher-expanded-child': row.expanded && !row.expandable,
                'voucher-collapsed': !row.expanded
              }" -->
              <!-- [class.voucher-expanded]="row.isParent && row.expanded"
            [class.voucher-expanded-child]="!row.isParent" -->

  
  <div class="row m-0 ml-3 mr-3 pt-2 pb-1" [hidden]="!dataSource">
    <div class="col-md-2">
      <button
        class="mt-3 btn font-size-12 button-btn"
        (click)="exportexcelAnnually()"
      >
        <i
          class="fa fa-file-export mr-1"
          style="font-size: medium; cursor: pointer"
        ></i>
        Export
      </button>
    </div>
    <div class="col-md-2">
      <button class="mt-3 btn font-size-12 button-btn" (click)="printdata()">
        <i
          class="fa fa-print mr-1"
          style="font-size: medium; cursor: pointer"
        ></i>
        Print
      </button>
    </div>

    <div class="col-md-2">
      <button
        class="mt-3 btn font-size-12 button-btn"
        (click)="printConfirmation()"
        style="width: max-content !important"
      >
        <i
          class="fa fa-print mr-1"
          style="font-size: medium; cursor: pointer"
        ></i>
        Print A/c. Confirmation
      </button>
    </div>

    <div class="col-md-6 text-right mt-3">
      <mat-paginator
        #PaginatorList
        [pageSizeOptions]="[20, 50]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>

  <div class="mt-3" *ngIf="dataSourceMonthly">
    <div class="">
      <div class="table-responsive">
        <mat-table
          [dataSource]="dataSourceMonthly"
          matSort
          matTableExporter
          #exporter="matTableExporter"
          style="max-width: 100%; overflow: auto"
        >
          <ng-container matColumnDef="Id">
            <mat-header-cell
             
              class="grid-header"
              style="max-width: 3.75rem"
              *matHeaderCellDef
              >#</mat-header-cell
            >
            <mat-cell
              *matCellDef="let row; let i = index"
              class="grid-cell"
              style="max-width: 3.75rem; max-height: 0.3125rem"
            >
              <!-- {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }} -->
              {{ i + 1 }}
            </mat-cell>
            <mat-footer-cell
              *matFooterCellDef
              style="max-width: 3.75rem"
            ></mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Month_Year">
            <mat-header-cell
             
              class="grid-header"
              *matHeaderCellDef
              >Month Year</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Month_Year }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Account_Name">
            <mat-header-cell
             
              class="grid-header"
              *matHeaderCellDef
            >
              Account Name
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Account_Name }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="accHead">
            <mat-header-cell
             
              class="grid-header"
              *matHeaderCellDef
              >Account Head</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.accHead }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>Total:</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="TranTypeDR">
            <mat-header-cell
             
              class="grid-header"
              *matHeaderCellDef
              >DR Amount</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.TranTypeDR }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>{{
              totaltypeMonthly("TranTypeDR")
            }}</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="TranTypeCR">
            <mat-header-cell
             
              class="grid-header"
              *matHeaderCellDef
              >CR Amount</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.TranTypeCR }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>{{
              totaltypeMonthly("TranTypeCR")
            }}</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="TranTypeTotal">
            <mat-header-cell
             
              class="grid-header"
              *matHeaderCellDef
              >Balance</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.TranTypeTotal }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>{{
              calculateMonthlyBalance()
            }}</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Action">
            <mat-header-cell
             
              class="grid-header"
              style="max-width: 6.25rem; justify-content: center"
              *matHeaderCellDef
            >
              View Detail
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row; let i = index"
              class="grid-cell text-center"
              style="max-width: 6.25rem"
            >
              <div
                *ngIf="row.Account_Name == 'Opening Balance'; else elseBlock"
              >
                &nbsp;
              </div>
              <ng-template #elseBlock>
                <i
                  class="fa fa-arrow-circle-right arrow-circle action-btn"
                  (click)="goToDetailModel(row)"
                  aria-label="true"
                ></i>
              </ng-template>
            </mat-cell>
            <mat-footer-cell
              *matFooterCellDef
              style="max-width: 6.25rem"
            ></mat-footer-cell>
          </ng-container>

          <mat-header-row
            *matHeaderRowDef="displayedColumnsMonthly; sticky: true"
          ></mat-header-row>
          <mat-row
            [ngClass]="{ Row_Bold: row.Account_Name == 'Opening Balance' }"
            *matRowDef="let row; columns: displayedColumnsMonthly"
          ></mat-row>
          <mat-footer-row
            class="sticky-footer fontcolor"
            *matFooterRowDef="displayedColumnsMonthly; sticky: true"
            style="background: var(--theme-primary)"
          ></mat-footer-row>
        </mat-table>

        <div class="row m-0 pt-2 pb-1">
          <div class="col-md-2">
            <button
              class="mt-3 btn font-size-12 button-btn"
              (click)="exportTableMonthly()"
            >
              <i
                class="fa fa-file-export mr-1"
                style="font-size: medium; cursor: pointer"
              ></i>
              Export
            </button>
          </div>
          <div class="col-md-2">
            <button
              class="mt-3 btn font-size-12 button-btn"
              (click)="printdata()"
            >
              <i
                class="fa fa-print mr-1"
                style="font-size: medium; cursor: pointer"
              ></i>
              Print
            </button>
          </div>

          <!-- <div class="col-md-2">
            <button
              class="mt-3 btn font-size-12 button-btn"
              (click)="printConfirmation()"
              style="width: max-content !important"
            >
              <i
                class="fa fa-print mr-1"
                style="font-size: medium; cursor: pointer"
              ></i>
              Print Confirmation
            </button>
          </div> -->

          <div class="col-md-6 text-right">
            <!-- <mat-paginator #paginatorRef [pageSizeOptions]="[20,50]" showFirstLastButtons> </mat-paginator> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-3" *ngIf="dataSourceDaily">
    <div class="">
      <div class="table-responsive">
        <mat-table
          [dataSource]="dataSourceDaily"
          matSort
          matTableExporter
          #exporter="matTableExporter"
          style="max-width: 100%; overflow: auto"
        >
          <ng-container matColumnDef="Id">
            <mat-header-cell
             
              class="grid-header"
              style="max-width: 3.75rem"
              *matHeaderCellDef
              >#</mat-header-cell
            >
            <mat-cell
              *matCellDef="let row; let i = index"
              class="grid-cell"
              style="max-width: 3.75rem; max-height: 0.3125rem"
            >
              <!-- {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }} -->
              {{ i + 1 }}
            </mat-cell>
            <mat-footer-cell
              *matFooterCellDef
              style="max-width: 3.75rem"
            ></mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Account_Name">
            <mat-header-cell
             
              class="grid-header"
              *matHeaderCellDef
            >
              Account Name
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Account_Name }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Voucher_Date">
            <mat-header-cell
             
              class="grid-header"
              *matHeaderCellDef
              >Voucher Date</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Voucher_Date | date }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>Total:</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="TranTypeDR">
            <mat-header-cell
             
              class="grid-header"
              *matHeaderCellDef
              >DR Amount</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.TranTypeDR }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>{{
              totaltypeDaily("TranTypeDR")
            }}</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="TranTypeCR">
            <mat-header-cell
             
              class="grid-header"
              *matHeaderCellDef
              >CR Amount</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.TranTypeCR }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>{{
              totaltypeDaily("TranTypeCR")
            }}</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="TranTypeTotal">
            <mat-header-cell
             
              class="grid-header"
              *matHeaderCellDef
              >Balance</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.TranTypeTotal }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>{{
              calculateDailyBalance()
            }}</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Action">
            <mat-header-cell
             
              class="grid-header"
              style="max-width: 6.25rem; justify-content: center"
              *matHeaderCellDef
            >
              View Detail
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row; let i = index"
              class="grid-cell text-center"
              style="max-width: 6.25rem"
            >
              <div
                *ngIf="row.Account_Name == 'Opening Balance'; else elseBlock"
              >
                &nbsp;
              </div>
              <ng-template #elseBlock>
                <i
                  class="fa fa-arrow-circle-right arrow-circle action-btn"
                  (click)="goToDetailModel(row)"
                  aria-label="true"
                ></i>
              </ng-template>
            </mat-cell>
            <mat-footer-cell
              *matFooterCellDef
              style="max-width: 6.25rem"
            ></mat-footer-cell>
          </ng-container>

          <mat-header-row
            *matHeaderRowDef="displayedColumnsDaily; sticky: true"
          ></mat-header-row>
          <mat-row
            [ngClass]="{ Row_Bold: row.Account_Name == 'Opening Balance' }"
            *matRowDef="let row; columns: displayedColumnsDaily"
          ></mat-row>
          <mat-footer-row
            class="sticky-footer fontcolor"
            *matFooterRowDef="displayedColumnsDaily; sticky: true"
            style="background: var(--theme-primary)"
          ></mat-footer-row>
        </mat-table>

        <div class="row m-0 pt-2 pb-1">
          <div class="col-md-2">
            <button
              class="mt-3 btn font-size-12 button-btn"
              (click)="exportTabledaily()"
            >
              <i
                class="fa fa-file-export mr-1"
                style="font-size: medium; cursor: pointer"
              ></i>
              Export
            </button>
          </div>
          <div class="col-md-2">
            <button
              class="mt-3 btn font-size-12 button-btn"
              (click)="printdata()"
            >
              <i
                class="fa fa-print mr-1"
                style="font-size: medium; cursor: pointer"
              ></i>
              Print
            </button>
          </div>

          <!-- <div class="col-md-2">
            <button
              class="mt-3 btn font-size-12 button-btn"
              (click)="printConfirmation()"
              style="width: max-content !important"
            >
              <i
                class="fa fa-print mr-1"
                style="font-size: medium; cursor: pointer"
              ></i>
              Print Confirmation
            </button>
          </div> -->
          <div class="col-md-6 text-right">
            <!-- <mat-paginator #paginatorRef [pageSizeOptions]="[20,50]" showFirstLastButtons> </mat-paginator> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade in"
  id="VoucherModel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div
    class="modal-dialog modal-dialog-centered"
    role="document"
    style="max-width: 71.25rem"
  >
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Voucher Detail
        </h6>
        <button
          type="button"
          class="close"
          (click)="OnCloseVoucherModel()"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>
      <div class="modal-body">
         <div class="col-md-12 float-right mt-2 mb-2">
        <button class="btn button-btn mr-1" (click)="OnClickExpandAll(dataSourceModel, modalTree)"  *ngIf="dataSourceModel">
          Expand All
        </button>
        <button class="btn button-btn" (click)="OnClickCollaspeAll(dataSourceModel, modalTree)"  *ngIf="dataSourceModel">
          Collapse All
        </button>
      </div>
        <div class="row">
          <div class="col-md-12">
            <div
              class="table-responsive"
              style="height: 22.6875rem; max-width: 100%;"
            >
              <table
                class="table-bordered"
                mat-table
                matSort
                [dataSource]="dataSourceModel"
                matTableExporter
                #exporter="matTableExporter"
              >
                <!-- <ng-container matColumnDef="voucherid">
                  <th
                   
                    mat-header-cell
                    *matHeaderCellDef
                    class="width50"
                  >
                    #
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let row; let i = index"
                    class="width50"
                  >
                    {{ Paginglist.pageIndex * Paginglist.pageSize + (i + 1) }}
                  </td>
                  <th mat-footer-cell *matFooterCellDef></th>
                </ng-container> -->
                <ng-container matColumnDef="voucherid">
                    <th mat-header-cell *matHeaderCellDef>#</th>

                    <td mat-cell *matCellDef="let row; let i = index">
                      
                      <button
                        *ngIf="row.expandable"
                        class="btn btn-sm btn-light toggle-btn"
                         (click)="toggleVoucherByNo(row.VoucherId, dataSourceModel, modalTree)"
                        aria-label="Toggle voucher"
                      >
                        <strong>{{ row.expanded ? '-' : '+' }}</strong>
                      </button>

                      <!-- <span *ngIf="!row.expandable">
                        {{ i + 1 }}
                      </span> -->
                    </td>
                    

            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>


                <ng-container matColumnDef="VoucherDate">
                  <th mat-header-cell *matHeaderCellDef>
                    Voucher Date
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <ng-container *ngIf="row.isParent">
                    {{ row.VoucherDate }}
                    </ng-container>
                  </td>
                  <th mat-footer-cell *matFooterCellDef></th>
                </ng-container>

                <ng-container matColumnDef="Voucher_No">
                  <th mat-header-cell *matHeaderCellDef>
                    Voucher No
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <ng-container *ngIf="row.isParent">
                    {{ row.Voucher_No }}
                    </ng-container>
                  </td>
                  <th mat-footer-cell *matFooterCellDef></th>
                </ng-container>

                <ng-container matColumnDef="Branch_Name">
                  <th mat-header-cell *matHeaderCellDef>
                    Branch Name
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <ng-container>
                    {{ row.Branch_Name }}
                    </ng-container>
                  </td>
                  <th mat-footer-cell *matFooterCellDef></th>
                </ng-container>

                <ng-container matColumnDef="CaseNo">
                  <th mat-header-cell *matHeaderCellDef>
                    Loan No
                  </th>
                  <td mat-cell *matCellDef="let row">{{ row.CaseNo }}</td>
                  <th mat-footer-cell *matFooterCellDef></th>
                </ng-container>

                <ng-container matColumnDef="accHead">
                  <th mat-header-cell *matHeaderCellDef>
                    A/C Head
                  </th>
                  <td mat-cell *matCellDef="let row">{{ row.accHead }}</td>
                  <th mat-footer-cell *matFooterCellDef>Total</th>
                </ng-container>
                <ng-container matColumnDef="TranType">
                  <!-- Header -->
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="text-center"
                  >
                    Details
                  </th>

                  <!-- Cell -->
                  <td mat-cell *matCellDef="let row" class="text-right">
                    <ng-container *ngIf="!row.isParent">
                    <div *ngIf="row.TranTypeCR && row.TranTypeCR != 0">
                      {{ row.TranTypeCR | number:'1.2-2' }} <span class="label-cr">(CR)</span>
                    </div>

                    <div *ngIf="row.TranTypeDR && row.TranTypeDR != 0">
                      {{ row.TranTypeDR | number:'1.2-2' }} <span class="label-dr">(DR)</span>
                    </div>
                    </ng-container>
                  </td>

                  <!-- Footer -->
                  <th mat-footer-cell *matFooterCellDef class="text-right">
                    <!-- <div>
                      {{ calculateACTranTypeCR() | number:'1.2-2' }} <span class="label-cr">(CR)</span>
                    </div>
                    <div>
                      {{ calculateACTranTypeDR() | number:'1.2-2' }} <span class="label-dr">(DR)</span>
                    </div> -->
                  </th>
                </ng-container>

                <ng-container matColumnDef="TranTypeDR">
                  <th
                   
                    mat-header-cell
                    *matHeaderCellDef
                    class="text-right"
                  >
                    DR Amount
                  </th>
                  <td mat-cell *matCellDef="let row" class="text-right">
                    {{ row.TranTypeDR }}
                  </td>
                  <th mat-footer-cell *matFooterCellDef class="text-right">
                    {{ dataSourceModel ? totaltypeModel("TranTypeDR") : "" }}
                  </th>
                </ng-container>

                <ng-container matColumnDef="TranTypeCR">
                  <th
                   
                    mat-header-cell
                    *matHeaderCellDef
                    class="text-right"
                  >
                    CR Amount
                  </th>
                  <td mat-cell *matCellDef="let row" class="text-right">
                    {{ row.TranTypeCR }}
                  </td>
                  <th mat-footer-cell *matFooterCellDef class="text-right">
                    {{ dataSourceModel ? totaltypeModel("TranTypeCR") : "" }}
                  </th>
                </ng-container>

                <ng-container matColumnDef="TranTypeTotal">
                  <th
                   
                    mat-header-cell
                    *matHeaderCellDef
                    class="text-right"
                  >
                    Balance
                  </th>
                  <td mat-cell *matCellDef="let row" class="text-right">
                    <ng-container *ngIf="row.isParent">
                    {{ row.TranTypeTotal }}
                    </ng-container>
                  </td>
                  <th mat-footer-cell *matFooterCellDef class="text-right">
                    {{ dataSourceModel ? totaltypeModelBal() : "" }}
                  </th>
                </ng-container>

                <ng-container matColumnDef="Narration">
                  <th mat-header-cell *matHeaderCellDef>
                    Narration
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <ng-container *ngIf="row.isParent">
                    {{ row.Narration }}
                    </ng-container>
                  </td>
                  <th mat-footer-cell *matFooterCellDef></th>
                </ng-container>


                <ng-container matColumnDef="Reference_No">
                  <th mat-header-cell *matHeaderCellDef>
                    Reference No
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <ng-container *ngIf="row.isParent">
                    {{ row.Reference_No }}
                    </ng-container>
                  </td>
                  <th mat-footer-cell *matFooterCellDef></th>
                </ng-container>

                <ng-container matColumnDef="ViewAction">
                  <th
                    mat-header-cell
                   
                    class="grid-header"
                    *matHeaderCellDef
                  >
                    View Detail
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let row; let i = index"
                    class="text-center"
                  >
                    <ng-container *ngIf="row.isParent">
                    <div
                      *ngIf="row.accHead == 'Opening Balance'; else elseBlock"
                    >
                      &nbsp;
                    </div>
                    <ng-template #elseBlock>
                      <app-lms-voucher-view-model
                        [voucherid]="row.voucherid"
                        (close)="GetData($event)"
                        [index]="i"
                      >
                        <i
                          class="fa fa-arrow-circle-right arrow-circle action-btn"
                          aria-label="true"
                        ></i>
                      </app-lms-voucher-view-model>
                    </ng-template>
                    </ng-container>
                  </td>
                  <th mat-footer-cell *matFooterCellDef></th>
                </ng-container>

                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumnsModel; sticky: true"
                ></tr>
                <tr
                  mat-row
                  [ngClass]="{ Row_Bold: row.accHead == 'Opening Balance' }"
                  *matRowDef="let row; columns: displayedColumnsModel"
                  [class.Row_Bold]="row.isParent"
                  [style.backgroundColor]="row.isParent ? 'rgb(195 213 240)' : null"
                ></tr>
                <tr
                  mat-footer-row
                  class="sticky-footer fontcolor"
                  *matFooterRowDef="displayedColumnsModel; sticky: true"
                ></tr>
              </table>
            </div>
          </div>
        </div>
        <div class="row m-0 pt-2 pb-1">
          <div class="col-md-12 text-right">
            <div class="col-md-2">
              <button
                class="mt-3 btn font-size-12 button-btn"
                (click)="exportexcelModel()"
              >
                <i
                  class="fa fa-file-export mr-1"
                  style="font-size: medium; cursor: pointer"
                ></i>
                Export
              </button>
            </div>

            <mat-paginator
              #Paginglist
              [pageSizeOptions]="[20, 50]"
              showFirstLastButtons
            ></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="AccBook" style="display: none">
  <table class="table-bordered">
    <tr style="background: var(--theme-primary) !important; text-align: left">
      <th colspan="2">Account Head</th>
      <th colspan="2">Date From</th>
      <th colspan="2">Date To</th>
    </tr>
    <tr style="text-align: left">
      <td style="text-align: left" colspan="2">{{ AccountHeadName }}</td>
      <td style="text-align: left" colspan="2">
        {{ VoucherDateFrom | date : "dd/MM/YY" }}
      </td>
      <td style="text-align: left" colspan="2">
        {{ VoucherDateTo | date : "dd/MM/YY" }}
      </td>
    </tr>
  </table>

  <table class="table-bordered">
    <tr style="background: var(--theme-primary) !important; text-align: left">
      <th>Voucher Date</th>
      <th>Clear Date</th>
      <th>Voucher No</th>
      <th>Loan No</th>
      <th>A/C Head</th>
      <th>DR Amount</th>
      <th>CR Amount</th>
      <th>Balance</th>
      <th>Narration</th>
      <th>Reference No</th>
    </tr>
    <tr
      style="text-align: left"
      *ngFor="let row; let i = index; of: dataSourceExcel"
    >
      <td style="text-align: left">{{ row.VoucherDate }}</td>
      <td style="text-align: left">{{ row.Voucher_Cheque_Clear_Date }}</td>
      <td style="text-align: left">{{ row.Voucher_No }}</td>
      <td style="text-align: left">{{ row.CaseNo }}</td>
      <td style="text-align: left">{{ row.accHead }}</td>
      <td style="text-align: left">{{ row.TranTypeDR }}</td>
      <td style="text-align: left">{{ row.TranTypeCR }}</td>
      <td style="text-align: left">{{ row.TranTypeTotal }}</td>
      <td style="text-align: left">{{ row.Narration }}</td>
      <td style="text-align: left">{{ row.Reference_No }}</td>
    </tr>
    <tr>
      <td style="text-align: left"></td>
      <td style="text-align: left"></td>
      <td style="text-align: left"></td>
      <td style="text-align: left"></td>
      <td style="text-align: left">Total</td>
      <td style="text-align: left">{{ calculateACTranTypeDR() }}</td>
      <td style="text-align: left">{{ calculateACTranTypeCR() }}</td>
      <td style="text-align: left">{{ calculateACTranTypeTotal() }}</td>
      <td style="text-align: left"></td>
    </tr>
  </table>
</div>

<table
  id="accounting_statement_annually"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th colspan="12" style="text-align: center; background: var(--theme-primary) !important; border: 1px solid #333; color: #fff; padding: 6px;">{{ currentUser.CompanyName }}</th>
  </tr>
  <tr>
    <th colspan="12" style="background: #e8f8f5; border: 1px solid #333; padding: 6px;">Address : {{ currentUser.CompanyAddress }}</th>
  </tr>
  <tr>
    <th colspan="10" style="text-align: left; background: #e8f8f5; border: 1px solid #333; padding: 6px;">
      Account Statement for : {{ AccountHeadName }}
    </th>
    <th colspan="2" style="text-align: right; background: #e8f8f5; border: 1px solid #333; padding: 6px;">
      Print Date : {{ Cur_Date | date : "dd/MM/yyyy" }}<br>
      Print By : {{ printedByUser }}
    </th>
  </tr>
  <tr>
    <th colspan="12" style="text-align: center; background: var(--theme-primary) !important; border: 1px solid #333; color: #fff; padding: 6px;">Account Statement for the period of - {{ VoucherDateFrom | date : "dd/MM/yyyy" }} to {{ VoucherDateTo | date : "dd/MM/yyyy" }}</th>
  </tr>
  <tr>
    <th style="background: var(--theme-primary) !important; text-align: left">#</th>
    <th style="background: var(--theme-primary) !important; text-align: left">
      Voucher Date
    </th>
    <!-- <th>Clear Date</th> -->
    <th style="background: var(--theme-primary) !important; text-align: left">Voucher No</th>
    <th style="background: var(--theme-primary) !important; text-align: left">Branch Name</th>
    <th style="background: var(--theme-primary) !important; text-align: left">Loan No</th>
    <th style="background: var(--theme-primary) !important; text-align: left">A/C Head</th>
    <th style="background: var(--theme-primary) !important; text-align: left">Details</th>
    <th style="background: var(--theme-primary) !important; text-align: left">DR Amount</th>
    <th style="background: var(--theme-primary) !important; text-align: left">CR Amount</th>
    <th style="background: var(--theme-primary) !important; text-align: left">Balance</th>
    <th style="background: var(--theme-primary) !important; text-align: left">Narration</th>
    <th style="background: var(--theme-primary) !important; text-align: left">Reference No</th>
  </tr>
  <tr
    style="text-align: left"
    *ngFor="let row; let i = index; of: exportRows"
    
  >
    <td>{{ i + 1 }}</td>

    <td style="text-align: left"[attr.style]="getCellStyle(row, 'text-align:right;')">{{  row.isParent  ? row.VoucherDate : ''}}</td>

    <td style="text-align: left"[attr.style]="getCellStyle(row, 'text-align:right;')">{{  row.isParent  ? row.Voucher_No : ''}}</td>
    <td style="text-align: left"[attr.style]="getCellStyle(row, 'text-align:right;')">{{ row.Branch_Name }}</td>
    <td style="text-align: left"[attr.style]="getCellStyle(row, 'text-align:right;')">{{ row.CaseNo }}</td>
    <td style="text-align: left"[attr.style]="getCellStyle(row, 'text-align:right;')">{{ row.accHead }}</td>
    <!-- <td style="text-align: left"[attr.style]="getCellStyle(row, 'text-align:right;')"><div *ngIf="row.TranTypeCR && row.TranTypeCR != 0">
                {{ !row.isParent  ? row.TranTypeCR | number:'1.2-2' : ''}} <span class="label-cr">(CR)</span>
              </div>

              <div *ngIf="row.TranTypeDR && row.TranTypeDR != 0">
                {{ !row.isParent  ? row.TranTypeDR | number:'1.2-2' : ''}} <span class="label-dr">(DR)</span>
              </div></td> -->
              <td [attr.style]="getCellStyle(row, 'text-align:right;')">
                <ng-container *ngIf="!row.isParent">

                  <div *ngIf="row.TranTypeCR && row.TranTypeCR != 0">
                    {{ row.TranTypeCR | number:'1.2-2' }}
                    <span>(CR)</span>
                  </div>

                  <div *ngIf="row.TranTypeDR && row.TranTypeDR != 0">
                    {{ row.TranTypeDR | number:'1.2-2' }}
                    <span>(DR)</span>
                  </div>

                </ng-container>
              </td>
    <td style="text-align: left"[attr.style]="getCellStyle(row, 'text-align:right;')">{{ row.isParent  ? row.TranTypeDR : '' }}</td>
    <td style="text-align: left"[attr.style]="getCellStyle(row, 'text-align:right;')">{{ row.isParent  ? row.TranTypeCR : '' }}</td>
    <td style="text-align: left" [attr.style]="getCellStyle(row, 'text-align:right;')">{{  row.isParent  ? row.TranTypeTotal : ''}}</td>
    <td style="text-align: left" [attr.style]="getCellStyle(row, 'text-align:right;')">{{  row.isParent  ? row.Narration : ''}}</td>
    <td style="text-align: left" [attr.style]="getCellStyle(row, 'text-align:right;')">{{  row.isParent  ? row.Reference_No : ''}}</td>
  </tr>
  <tfoot>
    <tr>
      <td style="background: var(--theme-primary) !important; text-align: left" colspan="7">
        <strong>Total: </strong>
      </td>
      <td style="background: var(--theme-primary) !important; text-align: left">
        <strong>{{ calculateACTranTypeDR() }}</strong>
      </td>
      <td style="background: var(--theme-primary) !important; text-align: left">
        <strong>{{ calculateACTranTypeCR() }}</strong>
      </td>
      <td style="background: var(--theme-primary) !important; text-align: left">
        <strong>{{ calculateACTranTypeTotal() }}</strong>
      </td>
      <td style="background: var(--theme-primary) !important">
        <strong></strong>
      </td>
      <td style="background: var(--theme-primary) !important">
        <strong></strong>
      </td>
    </tr>
  </tfoot>
</table>

<table
  *ngIf="dataSourceMonthly"
  id="accounting_statement_monthly"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th colspan="6" style="text-align: center; background: var(--theme-primary) !important; border: 1px solid #333; color: #fff; padding: 6px;">{{ currentUser.CompanyName }}</th>
  </tr>
  <tr>
    <th colspan="6" style="background: #e8f8f5; border: 1px solid #333; padding: 6px;">Address : {{ currentUser.CompanyAddress }}</th>
  </tr>
  <tr>
    <th colspan="4" style="text-align: left; background: #e8f8f5; border: 1px solid #333; padding: 6px;">
      Account Statement for : {{ AccountHeadName }}
    </th>
    <th colspan="2" style="text-align: right; background: #e8f8f5; border: 1px solid #333; padding: 6px;">
      Print Date : {{ Cur_Date | date : "dd/MM/yyyy" }}<br>
      Print By : {{ printedByUser }}
    </th>
  </tr>
  <tr>
    <th colspan="6" style="text-align: center; background: var(--theme-primary) !important; border: 1px solid #333; color: #fff; padding: 6px;">Account Statement for the period of - {{ VoucherDateFrom | date : "dd/MM/yyyy" }} to {{ VoucherDateTo | date : "dd/MM/yyyy" }}</th>
  </tr>
  <tr>
    <th style="background: var(--theme-primary) !important; text-align: left">#</th>
    <th style="background: var(--theme-primary) !important; text-align: left">Month Year</th>
    <th style="background: var(--theme-primary) !important; text-align: left">
      Account Name
    </th>
    <th style="background: var(--theme-primary) !important; text-align: left">DR Amount</th>
    <th style="background: var(--theme-primary) !important; text-align: left">CR Amount</th>
    <th style="background: var(--theme-primary) !important; text-align: left">Balance</th>
  </tr>
  <tr
    style="text-align: left"
    *ngFor="let x of FileCheckingList; let i = index"
  >
    <td>{{ i + 1 }}</td>
    <td style="text-align: left">{{ x.Month_Year }}</td>
    <td style="text-align: left">{{ x.Account_Name }}</td>
    <td style="text-align: left">{{ x.TranTypeDR }}</td>
    <td style="text-align: left">{{ x.TranTypeCR }}</td>
    <td style="text-align: left">{{ x.TranTypeTotal }}</td>
  </tr>
  <tfoot>
    <tr>
      <td style="background: var(--theme-primary) !important; text-align: right" colspan="3">
        <strong>Total: </strong>
      </td>
      <td style="background: var(--theme-primary) !important; text-align: right">
        <strong>{{ totaltypeMonthly("TranTypeDR") }}</strong>
      </td>
      <td style="background: var(--theme-primary) !important; text-align: right">
        <strong>{{ totaltypeMonthly("TranTypeCR") }}</strong>
      </td>
      <td style="background: var(--theme-primary) !important">
        <strong>{{ calculateMonthlyBalance() }}</strong>
      </td>
    </tr>
  </tfoot>
</table>

<table
  *ngIf="dataSourceDaily"
  id="accounting_statement_daily"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th colspan="6" style="text-align: center; background: var(--theme-primary) !important; border: 1px solid #333; color: #fff; padding: 6px;">{{ currentUser.CompanyName }}</th>
  </tr>
  <tr>
    <th colspan="6" style="background: #e8f8f5; border: 1px solid #333; padding: 6px;">Address : {{ currentUser.CompanyAddress }}</th>
  </tr>
  <tr>
    <th colspan="4" style="text-align: left; background: #e8f8f5; border: 1px solid #333; padding: 6px;">
      Account Statement for : {{ AccountHeadName }}
    </th>
    <th colspan="2" style="text-align: right; background: #e8f8f5; border: 1px solid #333; padding: 6px;">
      Print Date : {{ Cur_Date | date : "dd/MM/yyyy" }}<br>
      Print By : {{ printedByUser }}
    </th>
  </tr>
  <tr>
    <th colspan="6" style="text-align: center; background: var(--theme-primary) !important; border: 1px solid #333; color: #fff; padding: 6px;">Account Statement for the period of - {{ VoucherDateFrom | date : "dd/MM/yyyy" }} to {{ VoucherDateTo | date : "dd/MM/yyyy" }}</th>
  </tr>
  <tr>
    <th style="background: var(--theme-primary) !important; text-align: left">#</th>
    <th style="background: var(--theme-primary) !important; text-align: left">
      Voucher Date
    </th>
    <th style="background: var(--theme-primary) !important; text-align: left">
      Account Name
    </th>
    <th style="background: var(--theme-primary) !important; text-align: left">DR Amount</th>
    <th style="background: var(--theme-primary) !important; text-align: left">CR Amount</th>
    <th style="background: var(--theme-primary) !important; text-align: left">Balance</th>
  </tr>
  <tr
    style="text-align: left"
    *ngFor="let x of FileCheckingList; let i = index"
  >
    <td>{{ i + 1 }}</td>
    <td style="text-align: left">{{ x.Voucher_Date | date }}</td>
    <td style="text-align: left">{{ x.Account_Name }}</td>
    <td style="text-align: left">{{ x.TranTypeDR }}</td>
    <td style="text-align: left">{{ x.TranTypeCR }}</td>
    <td style="text-align: left">{{ x.TranTypeTotal }}</td>
  </tr>
  <tfoot>
    <tr>
      <td style="background: var(--theme-primary) !important; text-align: right" colspan="3">
        <strong>Total: </strong>
      </td>
      <td style="background: var(--theme-primary) !important; text-align: right">
        <strong>{{ totaltypeDaily("TranTypeDR") }}</strong>
      </td>
      <td style="background: var(--theme-primary) !important; text-align: right">
        <strong>{{ totaltypeDaily("TranTypeCR") }}</strong>
      </td>
      <td style="background: var(--theme-primary) !important">
        <strong>{{ calculateDailyBalance() }}</strong>
      </td>
    </tr>
  </tfoot>
</table>

<table
  id="accounting_statement_details"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th colspan="12" style="text-align: center; background: var(--theme-primary) !important; border: 1px solid #333; color: #fff; padding: 6px;">{{ currentUser.CompanyName }}</th>
  </tr>
  <tr>
    <th colspan="12" style="background: #e8f8f5; border: 1px solid #333; padding: 6px;">Address : {{ currentUser.CompanyAddress }}</th>
  </tr>
  <tr>
    <th colspan="10" style="text-align: left; background: #e8f8f5; border: 1px solid #333; padding: 6px;">
      Account Statement for : {{ AccountHeadName }}
    </th>
    <th colspan="2" style="text-align: right; background: #e8f8f5; border: 1px solid #333; padding: 6px;">
      Print Date : {{ Cur_Date | date : "dd/MM/yyyy" }}<br>
      Print By : {{ printedByUser }}
    </th>
  </tr>
  <tr>
    <th colspan="12" style="text-align: center; background: var(--theme-primary) !important; border: 1px solid #333; color: #fff; padding: 6px;">Account Statement for the period of - {{ VoucherDateFrom | date : "dd/MM/yyyy" }} to {{ VoucherDateTo | date : "dd/MM/yyyy" }}</th>
  </tr>
  <tr>
    <th style="background: var(--theme-primary) !important; text-align: left">#</th>
    <th style="background: var(--theme-primary) !important; text-align: left">
      Voucher Date
    </th>
    <!-- <th>Clear Date</th> -->
    <th style="background: var(--theme-primary) !important; text-align: left">Voucher No</th>
    <th style="background: var(--theme-primary) !important; text-align: left">Branch Name</th>
    <th style="background: var(--theme-primary) !important; text-align: left">Loan No</th>
    <th style="background: var(--theme-primary) !important; text-align: left">A/C Head</th>
    <th style="background: var(--theme-primary) !important; text-align: left">Details</th>
    <th style="background: var(--theme-primary) !important; text-align: left">DR Amount</th>
    <th style="background: var(--theme-primary) !important; text-align: left">CR Amount</th>
    <th style="background: var(--theme-primary) !important; text-align: left">Balance</th>
    <th style="background: var(--theme-primary) !important; text-align: left">Narration</th>
    <th style="background: var(--theme-primary) !important; text-align: left">Reference No</th>
  </tr>
  <tr
    style="text-align: left"
    *ngFor="let row of exportRows; let i = index"
     
  >
    <td>{{ i + 1 }}</td>

    <td style="text-align: left" [attr.style]="getCellStyle(row, 'text-align:right;')">{{ row.isParent  ? row.VoucherDate : '' }}</td>
    <td style="text-align: left" [attr.style]="getCellStyle(row, 'text-align:right;')">{{row.isParent  ? row.Voucher_No : '' }}</td>
    <td style="text-align: left"[attr.style]="getCellStyle(row, 'text-align:right;')">{{ row.Branch_Name }}</td>
    <td style="text-align: left" [attr.style]="getCellStyle(row, 'text-align:right;')">{{ row.CaseNo }}</td>
    <td style="text-align: left" [attr.style]="getCellStyle(row, 'text-align:right;')">{{ row.accHead }}</td>
    <td [attr.style]="getCellStyle(row, 'text-align:right;')">
                <ng-container *ngIf="!row.isParent">

                  <div *ngIf="row.TranTypeCR && row.TranTypeCR != 0">
                    {{ row.TranTypeCR | number:'1.2-2' }}
                    <span>(CR)</span>
                  </div>

                  <div *ngIf="row.TranTypeDR && row.TranTypeDR != 0">
                    {{ row.TranTypeDR | number:'1.2-2' }}
                    <span>(DR)</span>
                  </div>

                </ng-container>
              </td>
    <td style="text-align: left" [attr.style]="getCellStyle(row, 'text-align:right;')">{{ row.isParent  ? row.TranTypeDR : '' }}</td>
    <td style="text-align: left" [attr.style]="getCellStyle(row, 'text-align:right;')">{{ row.isParent  ? row.TranTypeCR : '' }}</td>
    <td style="text-align: left" [attr.style]="getCellStyle(row, 'text-align:right;')">{{row.isParent  ? row.TranTypeTotal : '' }}</td>
    <td style="text-align: left" [attr.style]="getCellStyle(row, 'text-align:right;')">{{row.isParent  ? row.Narration : '' }}</td>
    <td style="text-align: left" [attr.style]="getCellStyle(row, 'text-align:right;')">{{row.isParent  ? row.Reference_No : '' }}</td>
  </tr>
  <tfoot>
    <tr>
      <td
        style="
          background: var(--theme-primary) !important;
          text-align: left;
          text-align: right;
        "
        colspan="7"
      >
        <strong>Total: </strong>
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          text-align: left;
          text-align: right;
        "
      >
        <strong>{{
          dataSourceModel ? totaltypeModel("TranTypeDR") : ""
        }}</strong>
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          text-align: left;
          text-align: right;
        "
      >
        <strong>{{
          dataSourceModel ? totaltypeModel("TranTypeCR") : ""
        }}</strong>
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          text-align: left;
          text-align: right;
        "
      >
        <strong>{{ dataSourceModel ? totaltypeModelBal() : "" }}</strong>
      </td>
      <td
        style="
          background: var(--theme-primary) !important;
          text-align: left;
          text-align: right;
        "
      ></td>
      <td
        style="
          background: var(--theme-primary) !important;
          text-align: left;
          text-align: right;
        "
      ></td>
    </tr>
  </tfoot>
</table>

<div
  class="modal fade in"
  id="AccountStatementPrintModel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Account Statement
        </h6>
        <button
          type="button"
          (click)="onCloseAccountStatementPrintModel()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>

      <div class="modal-body">
        <div class="row m-0">
          <div class="text-right mt-2 mb-2">
            <button
              type="button"
              mat-raised-button
              class="mt-3 btn font-size-12 button-btn"
              (click)="
                onDocsPrint('AccountStatementcontent', 'Account Statement')
              "
            >
              Print
            </button>
          </div>
        </div>

        <div class="col-md-10 offset-1" id="AccountStatementcontent">
          <div style="float: right">
            <img
              src="{{ EmployeeProfileBaseUrl }}logo.png"
              alt="logo"
              style="width: 6.25rem; display: inline"
            />
          </div>

          <div style="clear: both">
            <div>
              <div
                style="
                  font-family: 'Times New Roman', Times, serif;
                  text-align: center;
                "
              >
                <h5>{{ currentUser.CompanyName }}</h5>
              </div>
              <div
                style="
                  font-family: 'Times New Roman', Times, serif;
                  text-align: center;
                "
              >
                <h6>Address : {{ currentUser.CompanyAddress }}</h6>
              </div>
            </div>
          </div>

          <div
            style="
              text-align: center;
              font-family: 'Times New Roman', Times, serif;
            "
          >
            Account Statement for : {{ AccountHeadName }}
          </div>
          <div class="row m-0 mt-4 mb-4">
            <div
              class="col-md-12 text-center"
              style="
                font-family: 'Times New Roman', Times, serif;
                text-align: center;
              "
            >
              Account Statement for the period of -
              {{ VoucherDateFrom | date : "dd/MM/yyyy" }} to
              {{ VoucherDateTo | date : "dd/MM/yyyy" }}
            </div>
          </div>

          <div class="table-responsive mt-2">
            <table
              id="accounting_statement_annually"
              *ngIf="dataSource"
              class="table table-bordered bg-white"
              style="
                font-family: 'Times New Roman', Times, serif;
                margin-top: 1.25rem;
              "
            >
              <thead>
                <tr>
                  <th style="background: var(--theme-primary) !important; text-align: left">
                    #
                  </th>
                  <th style="background: var(--theme-primary) !important; text-align: left">
                    Voucher Date
                  </th>
                  <!-- <th>Clear Date</th> -->
                  <th style="background: var(--theme-primary) !important; text-align: left">
                    Voucher No
                  </th>
                  <th style="background: var(--theme-primary) !important; text-align: left">
                    Loan No
                  </th>
                  <th style="background: var(--theme-primary) !important; text-align: left">
                    A/C Head
                  </th>
                  <th style="background: var(--theme-primary) !important; text-align: left">
                    Details
                  </th>
                  <th style="background: var(--theme-primary) !important; text-align: left">
                    DR Amount
                  </th>
                  <th style="background: var(--theme-primary) !important; text-align: left">
                    CR Amount
                  </th>
                  <th style="background: var(--theme-primary) !important; text-align: left">
                    Balance
                  </th>
                  <th style="background: var(--theme-primary) !important; text-align: left">
                    Narration
                  </th>
                  <th style="background: var(--theme-primary) !important; text-align: left">
                    Reference No
                  </th>
                </tr>
              </thead>

              <tr
                style="text-align: left"
                *ngFor="let row; let i = index; of: displayRows"
                [class.Row_Bold]="row.isParent"
                [style.backgroundColor]="row.isParent ? '#DFFFF5' : null"
              >
                <td>{{ i + 1 }}</td>

                <td style="text-align: left">{{ row.isParent  ? row.VoucherDate : '' }}</td>

                <td style="text-align: left">{{row.isParent  ? row.Voucher_No : '' }}</td>
                <td style="text-align: left">{{row.isParent  ? row.CaseNo : '' }}</td>
                <td style="text-align: left">{{ row.accHead }}</td>
                <td style="text-align: left">
                <ng-container *ngIf="!row.isParent">

                  <div *ngIf="row.TranTypeCR && row.TranTypeCR != 0">
                    {{ row.TranTypeCR | number:'1.2-2' }}
                    <span>(CR)</span>
                  </div>

                  <div *ngIf="row.TranTypeDR && row.TranTypeDR != 0">
                    {{ row.TranTypeDR | number:'1.2-2' }}
                    <span>(DR)</span>
                  </div>

                </ng-container>
              </td>
                <td style="text-align: left">{{row.isParent  ? row.TranTypeDR : '' }}</td>
                <td style="text-align: left">{{row.isParent  ? row.TranTypeCR : '' }}</td>
                <td style="text-align: left">{{row.isParent  ? row.TranTypeTotal : '' }}</td>
                <td style="text-align: left">{{row.isParent  ? row.Narration : '' }}</td>
                <td style="text-align: left">{{row.isParent  ? row.Reference_No : '' }}</td>

              </tr>

              <tr>
                <td
                  style="background: var(--theme-primary) !important; text-align: left"
                  colspan="6"
                >
                  <strong>Total: </strong>
                </td>
                <td style="background: var(--theme-primary) !important; text-align: left">
                  <strong>{{ calculateACTranTypeDR() }}</strong>
                </td>
                <td style="background: var(--theme-primary) !important; text-align: left">
                  <strong>{{ calculateACTranTypeCR() }}</strong>
                </td>
                <td style="background: var(--theme-primary) !important; text-align: left">
                  <strong>{{ calculateACTranTypeTotal() }}</strong>
                </td>
                <td style="background: var(--theme-primary) !important; text-align: left">
                  <strong></strong>
                </td>
                <td style="background: var(--theme-primary) !important; text-align: left">
                  <strong></strong>
                </td>
              </tr>
            </table>
            <table
              *ngIf="dataSourceMonthly"
              id="accounting_statement_monthly"
              class="table table-bordered bg-white"
              style="font-family: 'Times New Roman', Times, serif"
            >
              <tr>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  #
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  Month Year
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  Account Name
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  DR Amount
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  CR Amount
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  Balance
                </th>
              </tr>
              <tr
                style="text-align: left"
                *ngFor="let x of FileCheckingList; let i = index"
              >
                <td>{{ i + 1 }}</td>
                <td style="text-align: left">{{ x.Month_Year }}</td>
                <td style="text-align: left">{{ x.Account_Name }}</td>
                <td style="text-align: left">{{ x.TranTypeDR }}</td>
                <td style="text-align: left">{{ x.TranTypeCR }}</td>
                <td style="text-align: left">{{ x.TranTypeTotal }}</td>
              </tr>
              <tfoot>
                <tr>
                  <td
                    style="background: var(--theme-primary) !important; text-align: right"
                    colspan="3"
                  >
                    <strong>Total: </strong>
                  </td>
                  <td style="background: var(--theme-primary) !important; text-align: right">
                    <strong>{{ totaltypeMonthly("TranTypeDR") }}</strong>
                  </td>
                  <td style="background: var(--theme-primary) !important; text-align: right">
                    <strong>{{ totaltypeMonthly("TranTypeCR") }}</strong>
                  </td>
                  <td style="background: var(--theme-primary) !important">
                    <strong>{{ calculateMonthlyBalance() }}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>

            <table
              *ngIf="dataSourceDaily"
              id="accounting_statement_daily"
              class="table table-bordered bg-white"
              style="font-family: 'Times New Roman', Times, serif"
            >
              <tr>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  #
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  Voucher Date
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  Account Name
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  DR Amount
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  CR Amount
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  Balance
                </th>
              </tr>
              <tr
                style="text-align: left"
                *ngFor="let x of FileCheckingList; let i = index"
              >
                <td>{{ i + 1 }}</td>
                <td style="text-align: left">{{ x.Voucher_Date | date }}</td>
                <td style="text-align: left">{{ x.Account_Name }}</td>
                <td style="text-align: left">{{ x.TranTypeDR }}</td>
                <td style="text-align: left">{{ x.TranTypeCR }}</td>
                <td style="text-align: left">{{ x.TranTypeTotal }}</td>
              </tr>
              <tfoot>
                <tr>
                  <td
                    style="background: var(--theme-primary) !important; text-align: right"
                    colspan="3"
                  >
                    <strong>Total: </strong>
                  </td>
                  <td style="background: var(--theme-primary) !important; text-align: right">
                    <strong>{{ totaltypeDaily("TranTypeDR") }}</strong>
                  </td>
                  <td style="background: var(--theme-primary) !important; text-align: right">
                    <strong>{{ totaltypeDaily("TranTypeCR") }}</strong>
                  </td>
                  <td style="background: var(--theme-primary) !important">
                    <strong>{{ calculateDailyBalance() }}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
            <div
              id="abc"
              style="
                float: right;
                text-align: right;
                font-family: 'Times New Roman', Times, serif;
              "
            >
              Issue Date & Time: {{ Cur_Date | date : "dd/MM/yyyy hh:mm:ss" }}<br>
              Issued By : {{ printedByUser }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade in"
  id="AccountStatementConfirmationPrintModel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Print Confirmation
        </h6>
        <button
          type="button"
          (click)="onCloseAccountStatementConfirmationPrintModel()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>

      <div class="modal-body">
        <div class="row m-0">
          <div class="text-right mt-2 mb-2">
            <button
              type="button"
              mat-raised-button
              class="mt-3 btn font-size-12 button-btn"
              (click)="
                onDocsPrint(
                  'AccountStatementConfirmationcontent',
                  'Account Statement Confirmation'
                )
              "
            >
              Print
            </button>
          </div>
        </div>

        <div
          class="col-md-10 offset-1"
          id="AccountStatementConfirmationcontent"
        >
          <div>
            <div style="display: flex; justify-content: space-between">
              <div style="max-width: 48%; word-break: break-word;">
                <p style="font-weight: 500">
                  From:
                  {{ currentUser.CompanyName }} <br />{{
                    currentUser.CompanyAddress
                  }}
                </p>
              </div>
              <div style="max-width: 48%; word-break: break-word; text-align: right;">
                <p style="font-weight: 500">
                  To:
                  {{ AccountHeadName }} <br />
                  {{ AccountAddress }}
                </p>
              </div>
            </div>

            <div>
              <div style="display: flex; justify-content: space-between">
                <span>Dear Sir/Madam,</span>
                <span>Date:{{ Cur_Date | date : "dd/MM/yyyy" }}</span>
              </div>

              <div>
                <p
                  style="
                    font-weight: 500;
                    text-align: center;
                    margin-bottom: 0px !important;
                  "
                >
                  Sub:Confirmation of Accounts
                </p>
                <p style="text-align: center; text-decoration: underline">
                  {{ VoucherDateFrom | date : "dd/MM/yyyy" }} to
                  {{ VoucherDateTo | date : "dd/MM/yyyy" }}
                </p>

                <p>
                  Given below is the details of your Accounts as standing in
                  my/our Books of Accounts for the above mentioned period.Kindly
                  return 3 copies stating your I.T. Permanent A/c No., duly
                  signed and sealed, in confirmation of the same. Please note
                  that if no reply is received from you within a fortnight, it
                  will be assumed that you have accepted the balance shown
                  below.
                </p>
              </div>
            </div>
          </div>

          <div class="table-responsive mt-2">
            <table
              id="accounting_statement_annually"
              *ngIf="dataSource"
              class="table table-bordered bg-white"
              style="
                font-family: 'Times New Roman', Times, serif;
                margin-top: 1.25rem;
                table-layout: fixed;
                width: 100%;
                font-size: 0.75rem;
              "
            >
              <thead>
                <tr>
                  <th style="background: var(--theme-primary) !important; text-align: left; white-space: nowrap; width: 3%;">
                    #
                  </th>
                  <th style="background: var(--theme-primary) !important; text-align: left; white-space: nowrap; width: 10%;">
                    Voucher Date
                  </th>
                  <!-- <th>Clear Date</th> -->
                  <th style="background: var(--theme-primary) !important; text-align: left; white-space: nowrap; width: 8%;">
                    Voucher No
                  </th>
                  <!-- <th style="background: var(--theme-primary) !important; text-align: left">
                    Loan No
                  </th> -->
                  <th style="background: var(--theme-primary) !important; text-align: left; white-space: nowrap; width: 25%;">
                    A/C Head
                  </th>
                  <th style="background: var(--theme-primary) !important; text-align: left; white-space: normal; width: 7%;">
                    Details
                  </th>
                  <th style="background: var(--theme-primary) !important; text-align: left; white-space: nowrap; width: 8%;">
                    Debit
                  </th>
                  <th style="background: var(--theme-primary) !important; text-align: left; white-space: nowrap; width: 8%;">
                    Credit
                  </th>
                  <th style="background: var(--theme-primary) !important; text-align: left; white-space: nowrap; width: 10%;">
                    Balance
                  </th>
                  <th style="background: var(--theme-primary) !important; text-align: left; white-space: normal; width: 17%;">
                    Narration
                  </th>
                  <!-- <th style="background: var(--theme-primary) !important; text-align: left">
                    Reference No
                  </th> -->
                </tr>
              </thead>

              <tr
                style="text-align: left"
                *ngFor="let row; let i = index; of: displayRows"
                [class.Row_Bold]="row.isParent"
               [style.backgroundColor]="row.isParent ? '#DFFFF5' : null"
              >
                <td style="white-space: nowrap; font-size: 0.75rem;">{{ i + 1 }}</td>

                <td style="text-align: left; white-space: nowrap; font-size: 0.75rem;">{{ row.isParent  ? row.VoucherDate : '' }}</td>

                <td style="text-align: left; white-space: nowrap; font-size: 0.75rem;">{{ row.isParent  ? row.Voucher_No : '' }}</td>
                <!-- <td style="text-align: left">{{ row.isParent  ? row.CaseNo : '' }}</td> -->
                <td style="text-align: left; white-space: nowrap; font-size: 0.75rem;">{{ row.accHead }}</td>
                <td style="text-align: left; white-space: normal;">
                <ng-container *ngIf="!row.isParent">

                  <div *ngIf="row.TranTypeCR && row.TranTypeCR != 0">
                    {{ row.TranTypeCR | number:'1.2-2' }}
                    <span>(CR)</span>
                  </div>

                  <div *ngIf="row.TranTypeDR && row.TranTypeDR != 0">
                    {{ row.TranTypeDR | number:'1.2-2' }}
                    <span>(DR)</span>
                  </div>

                </ng-container>
              </td>
                <td style="text-align: right; white-space: nowrap; font-size: 0.75rem;">{{ row.isParent  ? row.TranTypeDR : '' }}</td>
                <td style="text-align: right; white-space: nowrap; font-size: 0.75rem;">{{ row.isParent  ? row.TranTypeCR : '' }}</td>
                <td style="text-align: right; white-space: nowrap; font-size: 0.75rem;">{{ row.isParent  ? row.TranTypeTotal : '' }}</td>
                <td style="text-align: left; white-space: normal; font-size: 0.75rem;">{{ row.isParent  ? row.Narration : '' }}</td>
                <!-- <td style="text-align: left">{{ row.isParent  ? row.Reference_No : '' }}</td> -->
              </tr>

              <tr>
                <td
                  style="background: var(--theme-primary) !important; text-align: left"
                  colspan="5"
                >
                  <strong>Total: </strong>
                </td>
                <td style="background: var(--theme-primary) !important; text-align: right">
                  <strong>{{ calculateACTranTypeDR() }}</strong>
                </td>
                <td style="background: var(--theme-primary) !important; text-align: right">
                  <strong>{{ calculateACTranTypeCR() }}</strong>
                </td>
                <td style="background: var(--theme-primary) !important; text-align: right">
                  <strong>{{ calculateACTranTypeTotal() }}</strong>
                </td>
                 <!-- <td style="background: var(--theme-primary) !important; text-align: left">
                  <strong></strong>
                </td> -->
                 <td style="background: var(--theme-primary) !important; text-align: left">
                  <strong></strong>
                </td>
              </tr>
            </table>
            <table
              *ngIf="dataSourceMonthly"
              id="accounting_statement_monthly"
              class="table table-bordered bg-white"
              style="font-family: 'Times New Roman', Times, serif"
            >
              <tr>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  #
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  Month Year
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  Account Name
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  DR Amount
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  CR Amount
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  Balance
                </th>
              </tr>
              <tr
                style="text-align: left"
                *ngFor="let x of FileCheckingList; let i = index"
              >
                <td>{{ i + 1 }}</td>
                <td style="text-align: left">{{ x.Month_Year }}</td>
                <td style="text-align: left">{{ x.Account_Name }}</td>
                <td style="text-align: right">{{ x.TranTypeDR }}</td>
                <td style="text-align: right">{{ x.TranTypeCR }}</td>
                <td style="text-align: right">{{ x.TranTypeTotal }}</td>
              </tr>
              <tfoot>
                <tr>
                  <td
                    style="background: var(--theme-primary) !important; text-align: right"
                    colspan="3"
                  >
                    <strong>Total: </strong>
                  </td>
                  <td style="background: var(--theme-primary) !important; text-align: right">
                    <strong>{{ totaltypeMonthly("TranTypeDR") }}</strong>
                  </td>
                  <td style="background: var(--theme-primary) !important; text-align: right">
                    <strong>{{ totaltypeMonthly("TranTypeCR") }}</strong>
                  </td>
                  <td style="background: var(--theme-primary) !important; text-align: right">
                    <strong>{{ calculateMonthlyBalance() }}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>

            <table
              *ngIf="dataSourceDaily"
              id="accounting_statement_daily"
              class="table table-bordered bg-white"
              style="font-family: 'Times New Roman', Times, serif"
            >
              <tr>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  #
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  Voucher Date
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  Account Name
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  DR Amount
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  CR Amount
                </th>
                <th style="background: var(--theme-primary) !important; text-align: left">
                  Balance
                </th>
              </tr>
              <tr
                style="text-align: left"
                *ngFor="let x of FileCheckingList; let i = index"
              >
                <td>{{ i + 1 }}</td>
                <td style="text-align: left">{{ x.Voucher_Date | date }}</td>
                <td style="text-align: left">{{ x.Account_Name }}</td>
                <td style="text-align: right">{{ x.TranTypeDR }}</td>
                <td style="text-align: right">{{ x.TranTypeCR }}</td>
                <td style="text-align: right">{{ x.TranTypeTotal }}</td>
              </tr>
              <tfoot>
                <tr>
                  <td
                    style="background: var(--theme-primary) !important; text-align: right"
                    colspan="3"
                  >
                    <strong>Total: </strong>
                  </td>
                  <td style="background: var(--theme-primary) !important; text-align: right">
                    <strong>{{ totaltypeDaily("TranTypeDR") }}</strong>
                  </td>
                  <td style="background: var(--theme-primary) !important; text-align: right">
                    <strong>{{ totaltypeDaily("TranTypeCR") }}</strong>
                  </td>
                  <td style="background: var(--theme-primary) !important; text-align: right">
                    <strong>{{ calculateDailyBalance() }}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-top: 0.3125rem;
              margin-right:0.5rem;
            "
          >
            <span>I/We hereby confirm the above</span>
            <span>Yours faithfully,</span>
          </div>

          <div class="row m-0 statement-end-container" style="margin-top: 1.125rem; width: 100%; display: flex; justify-content: space-between;">
            <div class="col-6 p-0 statement-end-block statement-end-block--left" style="width: 48%; text-align: left;">
              <p class="statement-line" style="margin: 0 0 0.5rem; font-weight: 500; line-height: 1.5;">
                <span class="statement-label" style="font-weight: 700; margin-right: 0.375rem;">From:</span>
                {{ currentUser?.CompanyName || "-" }}
              </p>
              <p class="statement-line" style="margin: 0 0 0.5rem; font-weight: 500; line-height: 1.5;">
                <span class="statement-label" style="font-weight: 700; margin-right: 0.375rem;">PAN No:</span>
                {{ currentUser?.Company_PAN || "" }}
              </p>
              <p class="statement-line statement-line--signature" style="margin: 1rem 0 0.5rem; font-weight: 500; line-height: 1.5;">
                <span class="statement-label" style="font-weight: 700; margin-right: 0.375rem;">Signature:</span>
                <span class="signature-space" style="display: inline-block; width: 13.75rem; height: 2.125rem;"></span>
              </p>
            </div>
            <div class="col-6 p-0 statement-end-block statement-end-block--right" style="width: 48%; display: flex; justify-content: flex-end;">
              <div class="statement-side-block" style="width: auto; min-width: 20rem;">
                <div class="statement-side-row" style="display: flex; margin-bottom: 0.5rem;">
                  <div class="statement-side-label" style="width: 1.8125rem; font-weight: 700; text-align: left;">To:</div>
                  <div class="statement-side-value" style="flex: 1; text-align: left; word-break: break-word; font-weight: 500;">{{ AccountHeadName || "-" }}</div>
                </div>
                <div class="statement-side-row" style="display: flex; margin-bottom: 0.5rem;">
                  <div class="statement-side-label" style="width: 5.75rem; font-weight: 700; text-align: left;">PAN No:</div>
                  <div class="statement-side-value" style="flex: 1; text-align: left; word-break: break-word; font-weight: 500;">{{ Acc_PanNo || "" }}</div>
                </div>
                <div class="statement-side-row" style="display: flex; margin-bottom: 0.5rem; padding-top: 0.875rem;">
                  <div class="statement-side-label statement-side-label--signature" style="width: 5.75rem; font-weight: 700; text-align: left;">Signature:</div>
                  <div class="statement-side-value statement-side-value--signature" style="flex: 1; text-align: left; word-break: break-word;">
                    <span class="signature-space" style="display: inline-block; width: 13.75rem; height: 2.125rem;"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
